import { Component, Input } from "@angular/core";

@Component({
  selector: "app-no-client-found",
  templateUrl: "./no-client-found.component.html",
  styleUrls: ["./no-client-found.component.css"]
})
export class NoClientFoundComponent {
  @Input() visibility = false;
  @Input() showWarning = true;
}
